import { render, staticRenderFns } from "./Section4.vue?vue&type=template&id=fe1b52ec"
import script from "./Section4.vue?vue&type=script&lang=js"
export * from "./Section4.vue?vue&type=script&lang=js"
import style0 from "./Section4.vue?vue&type=style&index=0&id=fe1b52ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports